export enum DataSourceType {
    PLATFORM_FINANCIAL = 'Financial Data',
    PLATFORM_ECONOMIC = 'Economic Data',
    GLOBAL_TRADE = 'Global Trade',
    WORKSPACE_ANALYTICS = 'Workspace Data',
    THIRD_PARTY = 'Custom Data Sources',
}

export interface DataSourceConnection {
    id: string;
    workspaceId: string;
    type: DataSourceType;
    provider: string;
    credentialsRef?: string;
}
